<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/hello' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin-top:15px;">
      <el-form
        ref="queryForm"
        size="small"
        :inline="true"
        label-width="1.36rem"
      >
        <el-form-item>
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-plus"
            @click="adddialogVisible = true"
            >添加角色</el-button
          >
        </el-form-item>
      </el-form>
      <!-- 表格 -->
      <el-table :data="roleListData" border stripe style="width: 100%">
        <el-table-column prop="Id" label="ID" width="180">
        </el-table-column>
        <el-table-column prop="role_id" label="角色ID" width="180">
        </el-table-column>
        <el-table-column prop="role_name" label="角色名称" width="180">
        </el-table-column>
        <el-table-column  prop="role_desc" label="角色描述"  width="180">
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间"> </el-table-column>
        <el-table-column prop="update_time" label="更新时间"> </el-table-column>
        <el-table-column label="操作" fixed="right" width="500">
          <template slot-scope="scope">
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="delRoledata(scope.row.role_id)"
              >删除</el-button
            >
            <el-button
              type="warning"
              icon="el-icon-setting"
              size="mini"
              @click="showSetRightDialog(scope.row)"
              >分配权限
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 添加角色弹窗 -->
    <el-dialog title="添加角色" :visible.sync="adddialogVisible" width="50%">
      <el-form
        :model="addruleForm"
        :rules="addrules"
        ref="addruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="角色ID" prop="role_id">
          <el-input v-model="addruleForm.role_id"></el-input>
        </el-form-item>
        <el-form-item label="角色名称" prop="role_name">
          <el-input v-model="addruleForm.role_name"></el-input>
        </el-form-item>
        <el-form-item label="角色描述" prop="role_desc">
          <el-input v-model="addruleForm.role_desc"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addsubmitForm('addruleForm')"
            >确定</el-button
          >
          <el-button @click="addresetForm('addruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 编辑角色弹窗 -->
    <el-dialog title="编辑角色" :visible.sync="editdialogVisible" width="50%">
      <el-form
        :model="editruleForm"
        :rules="editrules"
        ref="editruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="角色ID" prop="role_id">
          <el-input v-model="editruleForm.role_id"></el-input>
        </el-form-item>
        <el-form-item label="角色名称" prop="role_name">
          <el-input v-model="editruleForm.role_name"></el-input>
        </el-form-item>
        <el-form-item label="角色描述" prop="role_desc">
          <el-input v-model="editruleForm.role_desc"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="editsubmitForm('editruleForm')"
            >确定</el-button
          >
          <el-button @click="editresetForm('editruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 分配权限 -->
    <el-dialog title="分配权限" :visible.sync="setRightDialogVisible">
      <el-tree
        :data="rightslist"
        :props="treeProps"
        show-checkbox
        node-key="id"
        ref="tree"
        :default-expanded-keys="defKeys"
        :default-checked-keys="defKeys"
      ></el-tree>
      <el-button @click="setRightDialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="allEditRights">确 定</el-button>
    </el-dialog>
    <!-- 分配权限 -->
  </div>
</template>

<script>
import { getcurrentTime, ConvertArray } from "@/utils/public";
import tree from "../../utils/tree.json";

export default {
  data() {
    return {
      roleSearchData: {
        versionName: "",
        versionNumber: "",
        status: "",
        forcedUpdate: "",
        time: ""
      },
      roleListData: [],
      adddialogVisible: false,
      addruleForm: {
        role_id: 0,
        role_name: "",
        role_desc: "",
        create_tiem: ""
      },
      addrules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" }
        ],
        roleDesc: [
          { required: true, message: "请填写描述内容", trigger: "blur" }
        ]
      },
      editdialogVisible: false,
      editruleForm: {
        role_id: 0,
        role_name: "",
        role_desc: "",
        create_tiem: ""
      },
      editrules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" }
        ],
        roleDesc: [
          { required: true, message: "请填写描述内容", trigger: "blur" }
        ]
      },
      // 所有角色数据列表
      rolesList: [],
      // 分配权限
      setRightDialogVisible: false,
      // 所有权限数据
      rightslist: [],
      // 树形控件的属性绑定对象
      treeProps: {
        label: "authName",
        children: "children"
      },
      // 默认选中的节点Id值数组
      defKeys: [],
      // 当前即将分配权限的角色Id
      roleId: 0,
      //是否清空数据
      isClearTree: 0,
    };
  },

  mounted() {
    // this.roleListData=roledata
    this.getRolesList();
  },

  methods: {
    // 获取角色列表的数据
    async getRolesList() {
      this.$axios.post("/3699BIApi/AdminRole/AllChildren", {}).then(res => {
        res.data.list.forEach(value => {
          value.children = ConvertArray(value.children);
        });
        this.roleListData = res.data.list;
        // console.log(this.roleListData);
      });
    },
    // 添加角色方法
    async addsubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // console.log(this.addruleForm);
          this.addruleForm.create_tiem = getcurrentTime();
          this.addruleForm.role_id = Number.parseInt(this.addruleForm.role_id);
          this.$axios.post("/3699BIApi/AdminRole/AddData", this.addruleForm).then(res => {
            // console.log(res);
            if (res.data.code == 200) {
              this.$message.success("添加角色成功");
              this.adddialogVisible = false;
              this.addruleForm = {
                roleName: "",
                roleDesc: "",
                create_tiem: ""
              };
              this.getRolesList();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addresetForm(formName) {
      this.$refs[formName].resetFields();
      this.adddialogVisible = false;
    },
    // 删除角色方法
    updateRoledata(id) {
      console.log(id);
      this.editdialogVisible = true
    },
    // 编辑角色方法
    async editsubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editresetForm(formName) {
      this.$refs[formName].resetFields();
      this.adddialogVisible = false;
    },
    // 删除角色方法
    delRoledata(id) {
      console.log(id);
      var itemId = Number.parseInt(id);
      this.$axios.post("/3699BIApi/AdminRole/DeleteData", { id:  itemId}).then(res => {
        // console.log(res);
        if (res.data.code == 200) {
          this.$message.success("删除角色成功");
          this.getRolesList();
        }
      });
    },

    // 1.分配权限方法
    async showSetRightDialog(row) {
      // console.log(row);
      this.roleId = row.role_id;
      this.setRightDialogVisible = true;
      // 请求树形接口
      this.rightslist = tree;
      
      if (this.isClearTree == 1) {
          this.$refs.tree.setCheckedKeys([]);
          //在0.1s后重新查询并加载树
          setTimeout(() => {
            let arr = [];
            arr = row.children;            
            this.$refs.tree.setCheckedKeys(arr);
            console.log("当前角色下所有权限的id", arr);
          }, 100);
      }
      else {
        let arr = [];
        arr = row.children;
        this.defKeys = arr;
        console.log("当前角色下所有权限的id", arr);
        this.isClearTree = 1;
      }
    },
    // 3.更新角色选择的权限
    async allEditRights() {
      let half = this.$refs.tree.getHalfCheckedKeys();
      let all = this.$refs.tree.getCheckedKeys();
      let str = all.join(",");
      console.log(str);
      let arr = {
        role_id: this.roleId,
        children: str
      };
      this.$axios.post("/3699BIApi/AdminRole/UpdateChildrenData", arr).then(res => {
        if (res.data.code == 200) {
          this.$message.success("修改权限成功");
          this.setRightDialogVisible = false;
          this.getRolesList();
        }
      });
    },
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/AdminManager/AdminRoleManager.vue